import React from 'react';

import { useLanguage } from '../i18n';
import LanguageSwitch from './LanguageSwitch';
import Logo from './Logo';

const Header = () => {
  const { t } = useLanguage();

  return (
    <header className='site-header sticky top-0 z-30 bg-canvas/[0.85] backdrop-blur-md'>
      <div className='container flex h-[72px] items-center justify-between gap-6'>
        <Logo />
        <nav aria-label={t.primaryNavLabel} className='ml-auto hidden md:block'>
          <ul className='flex items-center gap-8 text-[15px] font-medium text-muted'>
            {t.navigation.map((item) => (
              <li key={item.href}>
                <a
                  className='inline-flex min-h-[44px] items-center transition-colors hover:text-ink'
                  href={item.href}
                >
                  {item.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <LanguageSwitch />
      </div>
    </header>
  );
};

export default Header;
